import { createFileRoute, useParams } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { TutorPage } from "@/components/tutor/tutor-page";
import { requireRole } from "@/lib/session";

export const Route = createFileRoute("/teacher/tutor/$threadId")({
  ssr: false,
  beforeLoad: () => requireRole("teacher"),
  head: () => ({ meta: [{ title: "MAKAI Tutor · MAKAI Teachers" }] }),
  component: Page,
});

function Page() {
  const { threadId } = useParams({ from: "/teacher/tutor/$threadId" });
  return (
    <AppShell role="teacher" title="MAKAI Tutor" subtitle="Lesson plans, quizzes & class insights">
      <TutorPage role="teacher" threadId={threadId} />
    </AppShell>
  );
}
